module.exports = __webpack_public_path__ + "img/icon_img4.png";